/**
 * ./exercise4/Exercise4Finish.js
 * 
 * This module is similar with previous exercises. 
 * 
 */

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../exercise1/Exercise1Finish.css';
import Curtain from '../components/Curtain';
import Star1 from '../components/icons/star1.svg';
import Star2 from '../components/icons/star2.svg';
import TrueIcon from '../exercise1/icons/True.svg';
import FalseIcon from '../exercise1/icons/False.svg';
import { updateUserProgress } from '../utility';

const Exercise4Finish = () => {
  const [isCurtainActive, setIsCurtainActive] = useState(true);
  const [currentStep, setCurrentStep] = useState(1);
  const [ratings, setRatings] = useState({ ease: null, effectiveness: null });
  const navigate = useNavigate();
  const location = useLocation();
  const timeSpent = location.state?.timeSpent || 0;
  const duration = location.state?.duration || 5; // Get duration from navigation state
  const errorRate = location.state?.errorRate;

  useEffect(() => {
    const curtainTimer = setTimeout(() => {
      setIsCurtainActive(false);
    }, 2000);

    const welcomeTimer = setTimeout(() => {
      setCurrentStep(2);
    }, 3000);

    return () => {
      clearTimeout(curtainTimer);
      clearTimeout(welcomeTimer);
    };
  }, []);

  const handleRating = async (rating) => {
    if (currentStep === 2) {
          setRatings(prev => ({ ...prev, ease: rating }));
          setCurrentStep(3);
        } else if (currentStep === 3) {
          setRatings(prev => {
            const finalRatings = { ease: prev.ease, effectiveness: rating };
    
            try {
              // Only update progress if both ratings are 5
              const durations = [5, 10];
              if (finalRatings.ease === 5 && rating === 5) {
                updateUserProgress(4, duration, errorRate);
                if (durations.indexOf(duration) === durations.length - 1){
                  navigate('/exercise4fullycomplete');
                }else{
                  navigate("/exercise4summary", {
                    state: {
                      duration: duration
                    },
                  });
                }

              }else{
                navigate('/exercise4failed')
              }
              
            } catch (error) {
              console.error('Error tracking exercise:', error);
            }
    
            return finalRatings;
          });
    }
  };

  const renderContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="welcome-container">
            <div className="message-bubble">Hi, I'm Sunny! Just checking in.</div>
            <img src={Star1} alt="" className="star" />          
          </div>
        );
        case 2:
          return (
            <div className="rating-container">
              <div className="message-bubble">With steady breath, can you capture both picture and sentence?</div>
              <img src={Star2} alt="" className="star" />
              <div className="rating-section">
                <div className="button-column">
                  <button onClick={() => handleRating(1)} className="rating-button button-false"> <img src={FalseIcon} alt="No" className="false-icon" /> </button>
                  <div className="label">No</div>
                </div>
  
                <div className="button-column">
                  <button onClick={() => handleRating(5)} className="rating-button button-true"> <img src={TrueIcon} alt="Yes" className="true-icon" /> </button>
                  <div className="label">Yes</div>
                </div>
              </div>
            </div>
          );
        case 3:
          return (
            <div className="rating-container">
              <div className="message-bubble">With steady breath, can you comprehend the meaning of the sentence?</div>
              <img src={Star2} alt="" className="star" />
              <div className="rating-section">
                <div className="button-column">
                  <button onClick={() => handleRating(1)} className="rating-button button-false"> <img src={FalseIcon} alt="No" className="false-icon" /> </button>
                  <div className="label">No</div>
                </div>
  
                <div className="button-column">
                  <button onClick={() => handleRating(5)} className="rating-button button-true"> <img src={TrueIcon} alt="Yes" className="true-icon" /> </button>
                  <div className="label">Yes</div>
                </div>
              </div>
            </div>
          );
      default:
        return null;
    }
  };

  return (
    <div className="exercise-finish-container">
      {isCurtainActive && <Curtain disappear={true} duration={2000} />}
      {renderContent()}
    </div>
  );
};

export default Exercise4Finish;
